import React from "react";

const OfflineIcon = () => (
  <svg role="img" viewBox="0 0 24 24">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        transform="translate(2.000000, 2.000000)"
        fill="currentColor"
        fillRule="nonzero"
      >
        <path
          d="M8.85355339,2.14644661 L10.8535534,2.14644661 C12.5104076,2.14644661 13.8535534,3.48959236 13.8535534,5.14644661 L13.8535534,13.1464466 C13.8535534,14.8033009 12.5104076,16.1464466 10.8535534,16.1464466 L8.85355339,16.1464466 C6.09212964,16.1464466 3.85355339,13.9078704 3.85355339,11.1464466 L3.85355339,7.14644661 C3.85355339,4.38502286 6.09212964,2.14644661 8.85355339,2.14644661 Z M8.85355339,4.14644661 C7.19669914,4.14644661 5.85355339,5.48959236 5.85355339,7.14644661 L5.85355339,11.1464466 C5.85355339,12.8033009 7.19669914,14.1464466 8.85355339,14.1464466 L10.8535534,14.1464466 C11.4058381,14.1464466 11.8535534,13.6987314 11.8535534,13.1464466 L11.8535534,5.14644661 C11.8535534,4.59416186 11.4058381,4.14644661 10.8535534,4.14644661 L8.85355339,4.14644661 Z"
          transform="translate(8.853553, 9.146447) rotate(-45.000000) translate(-8.853553, -9.146447) "
        />
        <path
          d="M17,5.5 L14,5.5 C13.4477153,5.5 13,5.94771525 13,6.5 C13,7.05228475 13.4477153,7.5 14,7.5 L17,7.5 C17.5522847,7.5 18,7.05228475 18,6.5 C18,5.94771525 17.5522847,5.5 17,5.5 Z"
          transform="translate(15.500000, 6.500000) rotate(-45.000000) translate(-15.500000, -6.500000) "
        />
        <path
          d="M13,1.5 L10,1.5 C9.44771525,1.5 9,1.94771525 9,2.5 C9,3.05228475 9.44771525,3.5 10,3.5 L13,3.5 C13.5522847,3.5 14,3.05228475 14,2.5 C14,1.94771525 13.5522847,1.5 13,1.5 Z"
          transform="translate(11.500000, 2.500000) rotate(-45.000000) translate(-11.500000, -2.500000) "
        />
        <path
          d="M6,13.5 L1,13.5 C0.44771525,13.5 0,13.9477153 0,14.5 C0,15.0522847 0.44771525,15.5 1,15.5 L6,15.5 C6.55228475,15.5 7,15.0522847 7,14.5 C7,13.9477153 6.55228475,13.5 6,13.5 Z"
          transform="translate(3.500000, 14.500000) rotate(-45.000000) translate(-3.500000, -14.500000) "
        />
      </g>
    </g>
  </svg>
);

export default OfflineIcon;
